import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";

const BADGE = { active: "bg-amber-500/15 text-amber-300", ended: "bg-slate-800 text-slate-400", expired: "bg-slate-800 text-slate-500" };
const t = (iso) => iso ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

export const ActivityLog = ({ Card }) => {
  const [imps, setImps] = useState([]);
  const [audit, setAudit] = useState([]);
  useEffect(() => {
    api.get("/admin/impersonations").then((r) => setImps(r.data)).catch(() => {});
    api.get("/admin/audit-log").then((r) => setAudit(r.data)).catch(() => {});
  }, []);
  const rows = [
    ...imps.map((i) => ({ at: i.started_at, key: `i-${i.started_at}-${i.target_id}`, text: `${i.admin_name} ${i.kind === "portal" ? "opened the portal as client" : "impersonated"} ${i.target_name}`, badge: i.state,
      sub: i.ended_at ? `ended ${t(i.ended_at)}` : `expires ${t(i.expires_at)}` })),
    ...audit.map((a) => ({ at: a.at, key: a.id, text: `${a.by_name} deleted ${a.invoice_status} invoice ${a.invoice_number} (${money(a.amount, a.currency || "USD")})`, badge: "deleted" })),
  ].sort((a, b) => (b.at > a.at ? 1 : -1)).slice(0, 50);
  return (
    <Card title="Activity log" testId="settings-activity-log">
      {rows.length === 0 ? <p className="text-sm text-slate-500" data-testid="activity-empty">No impersonations or invoice deletions yet.</p> : (
        <div className="divide-y divide-slate-800 rounded-lg border border-slate-800 max-h-96 overflow-y-auto">
          {rows.map((r) => (
            <div key={r.key} className="flex items-center gap-3 px-4 py-2.5 text-sm" data-testid="activity-row">
              <span className={`text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full ${BADGE[r.badge] || "bg-rose-500/15 text-rose-300"}`}>{r.badge}</span>
              <span className="flex-1 text-slate-300">{r.text}</span>
              <span className="text-xs text-slate-500 num whitespace-nowrap">{t(r.at)}{r.sub ? ` · ${r.sub}` : ""}</span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
